import config from 'config'
import { htmlDecode } from '@vue-storefront/core/filters'

const DEFAULT_ARCHIVE_TITLE = 'Ratgeber | RuckZuck.store'
const DEFAULT_ARCHIVE_DESCRIPTION = 'Das RuckZuck DIY Magazin zur Bodenverlegung. Mit vielen Tipps & Tricks, damit Ihr nächstes Projekt ein Erfolg wird.'
const UNSET_ARCHIVE_TITLE = 'Eine weitere WordPress-Website'

const getPostImage = (post) => {
  if (post.featuredImage != null && post.featuredImage.node.sourceUrl != null) {
    return post.featuredImage.node.sourceUrl
  }
}

const plainSeoText = (value) => {
  if (!value) {
    return ''
  }

  const withoutMoreLink = String(value).replace(/<a[^>]*class="more-link"[^>]*>[\s\S]*?<\/a>/gi, ' ')
  const stripped = withoutMoreLink
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  return htmlDecode(stripped).replace(/(\.\.\.|\u2026)\s*$/, '').trim()
}

const publicPostsUrl = (slug?) => {
  const base = String(config.api.url || 'https://ruckzuck.store').replace(/\/$/, '')
  return slug ? `${base}/posts/${slug}` : `${base}/posts`
}

const archiveTitle = (title) => {
  const text = plainSeoText(title)
  if (!text || text.indexOf(UNSET_ARCHIVE_TITLE) !== -1) {
    return DEFAULT_ARCHIVE_TITLE
  }
  return text
}

const archiveDescription = (description) => {
  return plainSeoText(description) || DEFAULT_ARCHIVE_DESCRIPTION
}

const seoMetaInfo = ({ title, description, url, image, type }) => {
  const meta = []

  if (description) {
    meta.push({ vmid: 'description', name: 'description', content: description })
    meta.push({ vmid: 'og:description', property: 'og:description', content: description })
  }
  if (title) {
    meta.push({ vmid: 'og:title', property: 'og:title', content: title })
  }
  if (url) {
    meta.push({ vmid: 'og:url', property: 'og:url', content: url })
  }
  if (type) {
    meta.push({ vmid: 'og:type', property: 'og:type', content: type })
  }
  if (image) {
    meta.push({ vmid: 'og:image', property: 'og:image', content: image })
  }

  return {
    title,
    meta,
    link: url ? [{ vmid: 'canonical', rel: 'canonical', href: url }] : []
  }
}

export {
  getPostImage,
  plainSeoText,
  publicPostsUrl,
  archiveTitle,
  archiveDescription,
  seoMetaInfo
}
